import { useContext } from "react";
import C from "classnames";

import { ThemeContext, ThemeContextType } from "../ThemeContext";

import atlasLightLogo from "../../assets/sjLogos/sj-logo-atlas-light.svg";
import atlasDarkLogo from "../../assets/sjLogos/sj-logo-atlas-dark.svg";

import S from "./_ThemeLogo.module.scss";

export const ThemeLogo = ({ logoOnly = false }: { logoOnly?: boolean }) => {
  const { appliedTheme } = useContext(ThemeContext) as ThemeContextType;

  if (!appliedTheme) {
    return null;
  }

  const themeLogo = appliedTheme === "atlas-dark" ? atlasDarkLogo : atlasLightLogo;

  if (!logoOnly) {
    return (
      <a href="/">
        <img alt="Security Journey Logo" src={themeLogo} className={C(S.LoginLogo, S.AtlasLogo)} />
      </a>
    );
  } else {
    return <img alt="Security Journey Logo" src={themeLogo} />;
  }
};
